<!-- <script src="https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-core"></script>
<script src="https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-converter"></script>
<script src="https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-webgl"></script>
<script src="https://cdn.jsdelivr.net/npm/@tensorflow-models/handpose"></script> -->
<video autoplay playsinline muted id="webcam" width="300" height="300" #video></video>
<h2>Prueba</h2>
<tr  *ngFor="let prediction of predictions">
  <td>{{prediction.className}}</td>
  <td>{{prediction.probability}}</td>
</tr>